document.addEventListener("DOMContentLoaded", function () {

  const sliders = document.querySelectorAll(".m-image-comparison");

  if (!sliders.length) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.setAttribute("is-visible", "");
      }
    });
  }, { threshold: 0.25 });

  sliders.forEach(slider => {
    observer.observe(slider);

    const btn = slider.querySelector(".m-image-comparison__button");
    const after = slider.querySelector(".m-image-comparison__after");

    if (!btn || !after) return;

    const layout = slider.dataset.layout || "horizontal";

    let dragging = false;

    const setPercent = (percent) => {
      percent = Math.min(100, Math.max(0, percent));
      slider.style.setProperty("--percent", percent + "%");
    };

    const moveHandler = (e) => {
      if (!dragging) return;

      const rect = slider.getBoundingClientRect();

      if (layout === "horizontal") {
        const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        const percent = (x / rect.width) * 100;
        setPercent(percent);
      } else {
        const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
        const percent = (y / rect.height) * 100;
        setPercent(percent);
      }
    };

    const startDrag = () => {
      dragging = true;
      document.body.classList.add("image-comparing");
    };

    const stopDrag = () => {
      dragging = false;
      document.body.classList.remove("image-comparing");
    };

    btn.addEventListener("mousedown", startDrag);
    btn.addEventListener("touchstart", startDrag);

    window.addEventListener("mousemove", moveHandler);
    window.addEventListener("touchmove", moveHandler);

    window.addEventListener("mouseup", stopDrag);
    window.addEventListener("touchend", stopDrag);

    // Initialize center position
    setPercent(50);
  });
});
